import { render, staticRenderFns } from "./AdminLocationDataScan.vue?vue&type=template&id=b712cb7e&scoped=true&"
import script from "./AdminLocationDataScan.vue?vue&type=script&lang=js&"
export * from "./AdminLocationDataScan.vue?vue&type=script&lang=js&"
import style0 from "./AdminLocationDataScan.vue?vue&type=style&index=0&id=b712cb7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b712cb7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b712cb7e')) {
      api.createRecord('b712cb7e', component.options)
    } else {
      api.reload('b712cb7e', component.options)
    }
    module.hot.accept("./AdminLocationDataScan.vue?vue&type=template&id=b712cb7e&scoped=true&", function () {
      api.rerender('b712cb7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminLocationDataScan.vue"
export default component.exports